export const getErrorMessage = (error, fallback = 'Erro ao processar a requisição') => {
  if (!error) {
    return fallback
  }

  const responseData = error?.response?.data

  if (typeof responseData?.msg === 'string' && responseData.msg.trim().length > 0) {
    return responseData.msg
  }

  if (typeof responseData?.message === 'string' && responseData.message.trim().length > 0) {
    return responseData.message
  }

  const fieldErrors = responseData?.errors
  if (fieldErrors && typeof fieldErrors === 'object') {
    const firstFieldError = Object.values(fieldErrors).find(
      (msg) => typeof msg === 'string' && msg.trim().length > 0,
    )
    if (firstFieldError) {
      return firstFieldError
    }
  }

  if (typeof error?.message === 'string' && error.message.trim().length > 0) {
    return error.message
  }

  return fallback
}
